<template>
  <a-list item-layout="vertical" size="large" :data-source="listData" class="onboarding-list mb-120">
    <a-list-item slot="renderItem" key="item.title" slot-scope="item, index">
      <img slot="extra" alt="illustration" :src="item.image" class="onboarding-item-img" />
      <a-list-item-meta :description="item.description">
        <div slot="title" class="font-web onboarding-item-title-wrapper">
          <span class="onboarding-item-title">{{ item.title }}</span>
        </div>
      </a-list-item-meta>
      <div class="onboarding-item-content">
        <div class="content-section mb-10">
          <h4 class="font-web section-label">รายละเอียด</h4>
          <p class="font-web mt-0 mb-0">{{ item.content }}</p>
        </div>
        <div class="mt-15">
          <a-button type="link" :href="item.thLink" target="_blank" class="action-btn"><a-icon type="global" /> Link
            ภาษาไทย</a-button>
          <a-button type="link" :href="item.enLink" target="_blank" class="action-btn"><a-icon type="global" /> Link
            ภาษาอังกฤษ</a-button>
        </div>
      </div>
      <template slot="actions"></template>
    </a-list-item>
  </a-list>
</template>

<script>
export default {
  data() {
    return {
      listData: [
        {
          title: 'คู่มือธรรมาภิบาล',
          description: 'Governance Manual',
          content: 'แนวทางปฏิบัติและหลักเกณฑ์การบริหารจัดการที่ดี เพื่อความโปร่งใสและตรวจสอบได้ขององค์กร มุ่งเน้นการดำเนินงานที่มีคุณธรรมและประสิทธิภาพ',
          image: '/images/hri_dashboard/on_a.png',
          href: 'javascript:;',
          thLink: 'https://governance.mahidol.ac.th/wp-content/uploads/2023/09/คู่มือธรรมาภิบาลTH.pdf',
          enLink: 'https://mahidol.ac.th/governance/'
        },
        {
          title: 'ค่านิยมหลักขององค์กร',
          description: 'MUIC Core Values',
          content: 'ค่านิยมหลักที่เป็นหัวใจสำคัญในการขับเคลื่อนองค์กร มุ่งเน้นความสามัคคี นวัตกรรม และการบริการที่เป็นเลิศเพื่อสังคม',
          image: '/images/hri_dashboard/on_b.png',
          href: 'javascript:;',
          thLink: 'https://muic.mahidol.ac.th/th/about/',
          enLink: 'https://muic.mahidol.ac.th/en/about/'
        },
        {
          title: 'HR น่ารู้',
          description: 'HR Insights & Guidelines',
          content: 'รวบรวมข้อมูลสำคัญที่บุคลากรควรรู้ เกี่ยวกับระเบียบปฏิบัติ สวัสดิการ และการพัฒนาบุคลากรในด้านต่างๆ',
          image: '/images/hri_dashboard/on_c.png',
          href: 'javascript:;',
          thLink: 'https://muiclms.mahidol.ac.th/courses/course-v1:MUIC+036+3/about',
          enLink: 'https://muiclms.mahidol.ac.th/courses/course-v1:MUIC+036+3/about'
        }
      ]
    };
  }
};
</script>

<style scoped>
.onboarding-list {
  padding: 0 20px;
  margin-bottom: 200px;
}

.onboarding-item-title {
  font-size: 20px !important;
  font-weight: 800 !important;
  color: #1a1a2e !important;
  transition: color 0.3s ease;
}

.onboarding-item-title:hover {
  color: #4285F4 !important;
}

.onboarding-item-content {
  color: #595959;
  font-size: 14px;
  line-height: 1.6;
}

.section-label {
  font-size: 13px;
  font-weight: 700;
  color: #8c8c8c;
  text-transform: uppercase;
  margin-bottom: 5px;
  letter-spacing: 0.5px;
}

.onboarding-item-title-wrapper {
  margin-bottom: 4px;
}

.onboarding-item-img {
  width: 280px;
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
  object-fit: cover;
  transition: transform 0.3s ease;
}

@media (max-width: 768px) {
  .onboarding-list {
    padding: 0 10px;
  }

  .onboarding-item-title {
    font-size: 18px !important;
  }

  .onboarding-item-img {
    width: 100% !important;
    max-width: 320px;
    margin-top: 10px;
  }

  ::v-deep .ant-list-item-extra {
    margin-left: 0 !important;
    display: flex;
    justify-content: center;
  }
}

.action-btn {
  padding: 0;
  margin-right: 24px;
  font-weight: 600;
}

.mt-15 {
  margin-top: 15px;
}

.onboarding-item-img:hover {
  transform: scale(1.02);
}

.action-btn:hover {
  color: #4285F4;
}

@media (max-width: 576px) {
  .action-btn {
    display: block;
    margin-bottom: 8px;
    margin-right: 0;
  }
}

/* Custom layout adjustments for Ant Design list-item actions */
::v-deep .ant-list-item-action {
  margin-top: 20px;
}
</style>
